module.exports = __webpack_public_path__ + "static/media/gsheet_icon.5b06a84f.png";